<div *ngIf="title" class="title-icon">
    <i class="{{iconClasses}} fa-2x"></i>
    <span class="sr-only sr-only-focusable">{{ 'Title Icon' | translate }}</span>
</div>

<span *ngIf="password" 
    class="mapfre icon-container show-password" 
    [ngClass]="{ 'password' : password, 'show': focusShowIcon  }">
    <a  (click)="showPasswordFunction()" 
        [class.active]="passwordShow"
        class="label-icon" 
        *ngIf="showIconsForPassword">
        <ng-container *ngIf="isAcmic; else MAStateIcon">
            <!-- <i class="fas fa-eye"></i> -->
            <ng-container *ngIf="passwordShow; else passwordHide">
                <img src="assets/img/images/acmic-password-icon-no-view.svg" alt="icon view"/>
            </ng-container>
            <ng-template #passwordHide>
                <img src="assets/img/images/acmic-password-icon-view.svg" alt="icon no view"/>                
            </ng-template>
        </ng-container>
        <ng-template #MAStateIcon>
            <ng-container *ngIf="passwordShow; else passwordHide">
                <img src="assets/img/images/ma-icon-no-view.svg" width="24" height="24" alt="icon no view"/>
            </ng-container>
            <ng-template #passwordHide>
                <img src="assets/img/images/ma-icon-view.svg" width="24" height="24" alt="icon view"/>
            </ng-template>
        </ng-template>
        <span class="label-text sr-only sr-only-focusable" *ngIf="!passwordShow">{{ 'SHOW' | translate}}</span>
        <span class="label-text sr-only sr-only-focusable" *ngIf="passwordShow">{{ 'HIDE' | translate}}</span>
    </a>

    <a (click)="showPasswordFunction()"
        class="label-icon" 
        *ngIf="!showIconsForPassword">
        <span class="label-text" *ngIf="!passwordShow">{{ 'SHOW' | translate}}</span>
        <span class="label-text" *ngIf="passwordShow">{{ 'HIDE' | translate}}</span>
    </a>
</span>

<span *ngIf="!title && !password && iconFamily !== 'material-icons' && !header">
    <ng-container *ngIf="loginPageIcon; else otherIcons">
        <ng-container *ngIf="isAcmic && (alertType==='success' || alertType==='error'); else maIconCheck">
            <img src="./assets/SVG/icon-warning-acmic-{{alertType}}.svg" alt="warning icon">
        </ng-container>
        <ng-template #maIconCheck>
            <i class="{{iconClasses}}"></i>
            <span class="sr-only sr-only-focusable"><ng-content></ng-content></span>
        </ng-template>   
    </ng-container>
    <ng-template #otherIcons>
        <ng-container *ngIf="isAcmic && (alertType==='success'); else maIconCheck">
            <img src="./assets/SVG/icon-warning-acmic-{{alertType}}.svg" alt="warning icon">
        </ng-container>
        <ng-template #maIconCheck>
            <i class="{{iconClasses}}"></i>
            <span class="sr-only sr-only-focusable"><ng-content></ng-content></span>
        </ng-template>   
    </ng-template>
        
</span>

<span *ngIf="!title && !password && iconFamily === 'material-icons' && !header">
	<i class="material-icons">{{iconClasses}}</i>
	<span class="sr-only sr-only-focusable"><ng-content></ng-content></span>
</span>

<ng-container *ngIf="header">
  <div class="header-icon-icon-height">
    <ng-container *ngIf="iconFamily === 'material-icons'">
        <i class="material-icons">{{iconClasses}}</i>
    </ng-container>
    <ng-container *ngIf="iconFamily !== 'material-icons'">
        <i class="{{iconClasses}}"></i>
    </ng-container>
    <span class="sr-only sr-only-focusable"><ng-content></ng-content></span>
  </div>
</ng-container>